import DocumentUpload from "./DocumentUpload";
import axios from 'axios';
import { toast } from 'react-toastify';
import querystring from 'querystring';



const tabs = {
    'document': {
        'api': 'agent_document_history',
        'label': 'Document Upload',
        'component': DocumentUpload,
        'columns': [
            {
                name: '#',
                selector: row => row.serialNo,
                sortable: true,
            },
            {
                name: 'File',
                cell: row => (
                    <a
                        href={process.env.REACT_APP_IMAGE_URL+row.file_path}
                        download={row.upload_name}
                        target="_blank"
                        rel="noopener noreferrer"
                        style={{ color: '#007bff', textDecoration: 'underline', cursor: 'pointer' }}
                    >
                        {row.upload_name}
                    </a>
                ),
                sortable: true,
            },            
            {
                name: 'Uploaded At',
                selector: row => row.uploaded_at,
                sortable: true,

            },
            {
                name: 'Actions',
                cell: row => (
                    <button
                        onClick={() => handleFileDelete(row.id)}
                        style={{
                            backgroundColor: '#ff4d4f',
                            color: 'white',
                            border: 'none',
                            padding: '5px 10px',
                            borderRadius: '4px',
                            cursor: 'pointer'
                        }}
                    >
                        Delete
                    </button>
                ),
                ignoreRowClick: true,
                allowOverflow: true,
                button: true,
            }
            
        ]
    },
}


function addRowCount(data,page,perPage){

    const updatedData = data.map((item, index) => ({
        ...item,
        serialNo: ((page - 1) * perPage) + index + 1
    }));
    return updatedData;
  
}


const handleFileDelete = async (id) => {
    try {
        const confirmed = window.confirm('Are you sure you want to delete this file?');
        if (!confirmed) return;


        const res = await axios.post(
            `${process.env.REACT_APP_API_URL}delete_agent_document`,
            querystring.stringify({id})
        );

        if (res.data.success) {
            toast.success(res.data.message || 'File deleted successfully!', {
                position: "top-center",
                autoClose: 3000,
                hideProgressBar: true,
                closeOnClick: true,
                pauseOnHover: false,
                draggable: false,
                theme: "colored",
            });
            setTimeout(() => {
                window.location.reload(); // Refresh the page
            }, 1500);
            // Optional: Refresh data here
        } else {
            toast.error(res.data.message || 'Failed to delete file.', {
                position: "top-center",
                autoClose: 3000,
                hideProgressBar: true,
                closeOnClick: true,
                pauseOnHover: false,
                draggable: false,
                theme: "colored",
            });
        }
    } catch (error) {
        console.error('Delete error:', error);
        toast.error('Something went wrong while deleting.', {
            position: "top-center",
            autoClose: 3000,
            hideProgressBar: true,
            closeOnClick: true,
            pauseOnHover: false,
            draggable: false,
            theme: "colored",
        });
    }
};


export {tabs, addRowCount}